import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx={16} cy={16.001} r={16} fill="#25D366" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.933 8.068a10.355 10.355 0 00-7.393-3.067c-5.759 0-10.45 4.691-10.455 10.45 0 1.844.481 3.639 1.394 5.227L6 26.096l5.543-1.453a10.459 10.459 0 004.997 1.273h.005c5.759 0 10.45-4.691 10.455-10.455a10.413 10.413 0 00-3.067-7.393zM16.54 24.147a8.665 8.665 0 01-4.425-1.213l-.316-.19-3.288.861.877-3.207-.205-.331a8.65 8.65 0 01-1.329-4.621c0-4.781 3.9-8.68 8.691-8.68 2.32 0 4.5.906 6.145 2.545a8.645 8.645 0 012.54 6.145c-.004 4.796-3.904 8.69-8.69 8.69zm4.766-6.506c-.26-.13-1.543-.762-1.784-.852-.24-.085-.416-.13-.586.13-.176.261-.677.852-.827 1.023-.15.175-.306.195-.567.065-.26-.13-1.102-.406-2.1-1.298-.776-.692-1.298-1.549-1.453-1.81-.15-.26-.015-.4.115-.53.116-.116.26-.306.391-.457.13-.15.176-.26.26-.436.086-.175.046-.326-.02-.456-.064-.13-.586-1.418-.806-1.94-.21-.51-.426-.44-.587-.446-.15-.01-.325-.01-.5-.01a.961.961 0 00-.697.326c-.24.26-.912.892-.912 2.18 0 1.288.937 2.526 1.067 2.702.13.175 1.84 2.811 4.46 3.944.622.27 1.108.431 1.49.552.626.2 1.192.17 1.643.105.501-.075 1.544-.632 1.764-1.243.216-.612.216-1.133.15-1.243-.064-.11-.24-.176-.5-.306z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
